import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const getStocks = async (callback) => {
    await axios.get(`/stocks/`).then(res => {
        callback(res.data.response)
    })
}

export const getStockById = async (id, callback) => {
    await axios.get(`/stocks/${id}`).then(res => {
        callback(res.data.response)
    })
}

export const StockAPI = () => {
    const [stocks, setStocks] = useState([]);
    const [callback, setCallback] = useState(false);

    useEffect(() => {
        getStocks(res => {
            setStocks(res.data);
        })
    }, [callback])

    return {
        stocks: [stocks, setStocks],
        callback: [callback, setCallback]
    }
}